import { Component, OnInit, ViewEncapsulation, ViewChild, AfterContentInit, OnDestroy } from '@angular/core';
import { MatTable, MatDialog } from '@angular/material';
import { Installment, Parameter } from '@akiba/models_bimbo';
import { Subscription } from 'rxjs';
import { InfoDialogComponent } from '../../../dialogs/info-dialog/info-dialog.component';
import { UploadService } from '../../../services/upload.service';
import { DataSourceService } from '../../../services/data-source.service';
import { AuthenticationService } from 'projects/bimbo/src/app/services/authentication.service';
import { LogicService } from '../../../services/logic.service';
import { CancelConfirmDialogComponent } from '../../../dialogs/cancel-confirm-dialog/cancel-confirm-dialog.component';
import { NgModel } from '@angular/forms';

@Component({
  selector: 'app-permanent-installment-parameters',
  templateUrl: './permanent-installment-parameters.component.html',
  styleUrls: ['./permanent-installment-parameters.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PermanentInstallmentParametersComponent implements OnInit, OnDestroy {

  @ViewChild('installmentsTable', { static: false }) installmentsTable: MatTable<Installment>;

  @ViewChild('weeksControl', { static: false }) weeksControl: NgModel;
  @ViewChild('biWeeksControl', { static: false }) biWeeksControl: NgModel;
  @ViewChild('monthsControl', { static: false }) monthsControl: NgModel;

  displayedInstallmentsColumns: string[] = ['weeks', 'biWeeks', 'months', 'delete'];
  installments: Array<Installment> = new Array<Installment>();
  newInstallments: Array<Installment> = new Array<Installment>();
  toDelete: Array<Installment> = new Array<Installment>();
  installment: Installment = new Installment();
  appLogicChangesSubscription: Subscription = null;
  hasChanges = false;
  selectedIndex = 0;

  modParameter: Parameter | null = null;
  parameterSubscription: Subscription;

  constructor(public authService: AuthenticationService, private uploadService: UploadService, private dataService: DataSourceService, public dialog: MatDialog, public logicService: LogicService) {

    if (!this.logicService.dataManager.parameterDataLoader.parameters) {

      this.parameterSubscription = this.logicService.dataManager.parameterDataLoader.changes.subscribe(p => {

        if (p && p.response) {
          this.doSubscriptions();
        }

      });

      this.logicService.dataManager.parameterDataLoader.load();

    } else {

      this.doSubscriptions();

    }

  }

  ngOnInit() {
  }

  addInstallments() {

    if (this.installment.weeks > 100000) {

      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'El número de semanas es invalido.',
          close: 'Aceptar'
        }
      });

      return;

    }

    if (this.installment.biWeeks > 100000) {

      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'El número de catorcena es invalido.',
          close: 'Aceptar'
        }
      });

      return;

    }

    if (this.installment.months > 100000) {

      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'El número de meses es invalido.',
          close: 'Aceptar'
        }
      });

      return;

    }

    if (this.installment.weeks <= 0 || this.installment.biWeeks <= 0 || this.installment.months <= 0) {

      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'Tanto las semanas, catorcenas y meses deben de ser mayores a 0',
          close: 'Aceptar'
        }
      });

      return;

    }

    const aDate = new Date();
    this.installment.installmentID = aDate.getTime().toString();
    const installmentObj = this.installment.toAny();
    const nInstallmentCopy = new Installment(installmentObj);
    this.installments.push(nInstallmentCopy);
    this.newInstallments.push(this.installment);
    this.installment = new Installment();

    if (this.installmentsTable) {
      this.installmentsTable.renderRows();
    }


    this.weeksControl.reset();
    this.biWeeksControl.reset();
    this.monthsControl.reset();

    this.hasChanges = true;

  }

  deleteInstallments(index: number) {

    const deletedItem = this.installments.splice(index, 1);

    if (deletedItem.length > 0) {
      const newIndex = this.newInstallments.findIndex(item => item.installmentID === deletedItem[0].installmentID);
      if (newIndex !== -1) {
        this.newInstallments.splice(index, 1);
      }

      this.toDelete.push(deletedItem[0]);

    }

    this.hasChanges = true;
    this.installmentsTable.renderRows();

  }

  doSubscriptions() {

    if (this.logicService.dataManager.parameterDataLoader.installments && this.logicService.dataManager.parameterDataLoader.installments.length) {

      this.installments = this.logicService.dataManager.parameterDataLoader.installments.filter(element => element !== null);

    }

  }

  cancelSubscriptions() {

    if (this.appLogicChangesSubscription && !this.appLogicChangesSubscription.closed) {
      this.appLogicChangesSubscription.unsubscribe();
      this.appLogicChangesSubscription = null;
    }

    if (this.parameterSubscription && !this.parameterSubscription.closed) {
      this.parameterSubscription.unsubscribe();
      this.parameterSubscription = null;
    }

  }

  savePeriod() {
    const authUser = this.logicService.dataManager.principalDataLoader.employee ? this.logicService.dataManager.principalDataLoader.employee : this.authService.authEmployee;

    if (!this.hasChanges) {

      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'No se detectaron cambios que guardar.',
          close: 'Aceptar'
        }
      });

      return;

    }

    const dialogConfirmation = this.dialog.open(CancelConfirmDialogComponent, {
      data: {
        message: '¿Desea guardar los parámetros con la información dada?',
        cancelButton: 'Cancelar',
        confirmButton: 'Aceptar'
      }
    });

    dialogConfirmation.afterClosed().subscribe(result => {

      if (result) {
        let createDate = new Date();
        let paramLogs = {
          changeID: '',
          collection: 'installment',
          approvedUid: authUser.uid,
          approvedBy: {
            firstName: authUser.firstName,
            firstLastName: authUser.firstLastName,
            employeeNumber: authUser.workInformation.employeeNumber,
          },
          createDate: createDate,
          timeStamp: createDate.getTime()
        };
        const promises = new Array<Promise<any>>();
        this.newInstallments.forEach(element => {

          const iObj = element.toAny();
          paramLogs.changeID = iObj.installmentID;
          this.dataService.saveLogAdministratorActions(paramLogs ,'permanentInstallmentParameters');
          promises.push(this.dataService.saveInstallment(iObj));

        });

        this.toDelete.forEach(element => promises.push(this.dataService.deleteInstallment(element.toAny())));

        Promise.all(promises).then(() => {

          this.newInstallments = new Array<Installment>();
          this.toDelete = new Array<Installment>();

          this.weeksControl.reset();
          this.biWeeksControl.reset();
          this.monthsControl.reset();

          this.dialog.open(InfoDialogComponent, {
            data: {
              message: 'La información ha sido actualizada.',
              close: 'Aceptar'
            }
          });

        }).catch(error => {

          this.newInstallments = new Array<Installment>();
          this.toDelete = new Array<Installment>();

          this.dialog.open(InfoDialogComponent, {
            data: {
              message: 'No fue posible guardar la información, inténtelo mas tarde.',
              close: 'Aceptar'
            }
          });

        });

      }

    });

  }

  cancelChanges() {

    const dialogConfirmation = this.dialog.open(CancelConfirmDialogComponent, {
      data: {
        message: '¿Desea descartar los cambios hechos?',
        cancelButton: 'Cancelar',
        confirmButton: 'Aceptar'
      }
    });
    dialogConfirmation.afterClosed().subscribe(async result => {
      if (result) {
        this.toDelete = new Array<Installment>();
        this.installments = this.logicService.dataManager.parameterDataLoader.installments;
        this.installment = new Installment();
        this.weeksControl.reset(0);
        this.biWeeksControl.reset(0);
        this.monthsControl.reset(0);
      }
    });

  }

  ngOnDestroy(): void {
    this.cancelSubscriptions();
  }

}
